import React from "react";
import { Navbar, Footer, WhatsAppChat } from "./components";
import ConfigRoutes from "./ConfigRoutes";
import Seo from "./components/Seo";

const App = () => {
  return (
    <div className="main-wrapper">
      <Seo />
      <Navbar />
      <ConfigRoutes />
      <Footer />
      <WhatsAppChat />
    </div>
  );
};

export default App;
